import * as Sentry from "@sentry/react";

/**
 * Initialise Sentry error reporting for the web client.
 *
 * Reads the DSN from `VITE_SENTRY_DSN` (Vite only exposes `VITE_`-prefixed env
 * vars to the client bundle). When the DSN is absent we no-op by design, so
 * local dev and the build stay green without one — nothing is reported until a
 * DSN is supplied via the environment.
 */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    if (import.meta.env.DEV) {
      console.info("[sentry] VITE_SENTRY_DSN not set — error reporting disabled.");
    }
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
  });
}

/**
 * Report an error to Sentry. The single call site the app's error boundaries
 * use, so capture behaviour (and test mocking) lives in one place. A no-op
 * until `initSentry` has run with a DSN.
 */
export function captureError(error: unknown): void {
  Sentry.captureException(error);
}
